import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, reactive } from "vue";
  import { useAuctionStore } from "@/stores/AuctionStore";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'MessageCounter',
  props: {
    initCount: { default: 0 }
  },
  setup(__props: any) {

  const auctionStore = useAuctionStore();

  const props = __props;

  const state = reactive({
    count: props.initCount || 0
  });

  onMounted(async () => {
    if (auctionStore.user?.id) {
      window.Echo.private(`chat.${auctionStore.user.id}.message.count`).listen(
        ".chat.to_user.message.count",
        (e: { unreadCount: number }) => {
          state.count = e.unreadCount;
        }
      );
    }
  });

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("span", { class: "messages-counter" }, _toDisplayString(state.count > 999 ? "···" : state.count), 513)), [
    [_vShow, state.count > 0]
  ])
}
}

})